<template>
  <div class="body-section px-md-5">
    <div class="mt-2 head-info pa-0">
      <v-btn
        color="white"
        elevation="0"
        class="pa-0 font-weight-bold text-capitalize"
        :to="`/learning`"
      >
        <v-icon color="primary">mdi-chevron-left</v-icon> Course Overview
      </v-btn>
      <v-divider class="mx-4"></v-divider>
    
      <h3 class="primary--text mx-5 mt-3">{{ subjectName }}</h3>
      <v-breadcrumbs class="font-weight-bold mt-0" :items="items" small>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :href="item.href"
            :class="item.disabled ? 'black-text font-weight-bold ' : ''"
          >
            {{ item.text}}
          </v-breadcrumbs-item>
        </template>  
      </v-breadcrumbs>
      <v-row v-if="loadingTopic" class="mt-5">
        <v-col v-for="(_, index) in loaders" cols="12" md="3" lg="3" :key="index">
          <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="card"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
  </div>

    <v-row v-if="loadingTopic" class="my-5">
      <v-col v-for="(_, index) in loaders" cols="12" md="3" lg="3" :key="index">
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <template v-else>
      <template v-if="lessons.length">
        <div class="mx-md-5">
          <span class="mx-5">All lessons</span>
          <v-row v-if="lessons.length">
            <v-col
              v-for="(lesson, index) in lessons"
              :key="index"
              md="3"
              sm="12"
            >
              <v-card
                :color="active ? 'primary' : 'primary'"
                class="ma-1 lesson rounded-lg mx-auto"
                height="181"
                width="294"
                @click="toggle"
                :to="`/watch/${topicUuid}/${subTopicUuid}/${lesson.uuid}/`"
                rounded
              >
                <v-img
                  height="180"
                  :src="`https://via.placeholder.com/300X150/0033AA/?text=${lesson.title}`"
                ></v-img>
                <div class="play">
                  <v-icon dark>mdi-play</v-icon>
                </div>
              </v-card>
              <p class="text-truncate mx-5" style="max-width: 270px; margin:auto !important">
                {{ lesson.title }}
              </p>
            </v-col>
          </v-row>

          <NoData
            :image="studyImage"
            v-else
            :imageWidth="140"
            title=""
            subtitle="No Subtopics for this subject"
          />
        </div>
      </template>
      <div v-else class="no-items">
        <NoData
          :image="studyImage"
          :imageWidth="200"
          title=""
          :subtitle="`No Topics for ${subjectName}`"
        />
        <v-btn color="primary" link to="/learning" rounded>Back to List</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import studyImage from "@/assets/study.jpg";
export default {
  components: { NoData },
  metaInfo() {
    return {
      studyImage,
      title: `Guiomentor - ${this.subjectName} Lessons`,
      url: window.location.href,
      description: `Lessons for ${this.subjectName} ${this.topic.title}`,
    };
  },
  data() {
    return {
      topicTitle: "",
      gradeName: "",
      topicUuid: "",
      subTopicUuid: "",
      subjectName: "",
      subtopic_title: "",
      subjectId: null,
      gradeId: null,
      items: [],
      loadingTopic: true,
      loaders: [1, 2, 4, 5, 7],
      topic: [],
      lessons: [],
      studyImage,
      slide: null,
    };
  },
  async mounted() {
    try {
        this.loadingTopic = true;
        this.topicUuid = this.$router.history?.current?.params?.topicId;
        this.subTopicUuid = this.$router.history?.current?.params?.subTopicId;
        const { data } = await this.axios.get(
        `topics/${this.topicUuid}/`);
        const {data: lessons} = await this.axios.get(
        `topics/${this.subTopicUuid}/lessons`);
        this.lessons = lessons.results;

      this.items = [
        {
          text: data?.title,
          disabled: false,
          href: `/learning/${data?.grade_level?.id}/${data?.subject?.id}/topics`,
        },
        {
          text: this.subtopic_title,
          disabled: true,
          href: "#",
        },
      ];
    } catch (error) {
      console.error(error);
    } finally {
      this.loadingTopic = false;
    }
  },
};
</script>

<style lang="scss">
@import "~vuetify/src/styles/settings/_variables";
.wrapper {
  min-height: 100vh;
}

.slider-item {
  text-align: center;
}

.no-items {
  text-align: center;
}
.body-section {
  height: 85vh;
  margin-top: 4.5em;
  overflow-y:auto;
  display: flex;
  flex-direction: column;
  border-radius: 1em;
  background-color: #f5f6f8;
  background-color: white;
}
.lesson{
  border-radius: 10em;
}
.play{
  position: absolute;
  top: 8px;
  right: 8px;
  width: 25px;
  height:25px;
  background-color: #bbb;
  border-radius: 50% !important;
  display: inline-block;
  text-align:center;
}
.black-text > *{
  color:black !important;
}
.head-info{
  position: sticky;
  top:0px;
  background-color: white;
  z-index: 5;
}

::-webkit-scrollbar {
  width: 9px;
  right: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 15px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .body-section {
    margin-top: 8em;
  }
}

</style>
